/**
 * Created by h3 on 2018-10-22.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Back, TimelineLite, TweenLite} from "gsap";
import {FruitsGameAssets} from "../FruitsGameAssets";
import {FruitsGameConfig} from "../FruitsGameConfig";
import {FruitsGameModuleConfig} from "../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../FruitsSoundConfig";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {BigStickySymbolController} from "./BigStickySymbolController";

export interface ISpriteObject {
    sprite:PIXI.Sprite,
    originX:number,
    originY:number,
    toX:number,
    toY:number
}


export class BigStickySymbolAndBonusView extends BaseView {

    private _layer:ScalableLayer;
    private _container:PIXI.Container;
    private _orientation:Orientation;
    private _screenWidth:number;
    private _screenHeight:number;
    private _leftOffset:number;
    private _topOffset:number;
    private _centerX:number = FruitsGameConfig.instance.GAME_WIDTH * 0.5;
    private _centerY:number = FruitsGameConfig.instance.GAME_HEIGHT * 0.5;
    private _screenX:number;
    private _screenY:number;


    private _backgroundImage:PIXI.TilingSprite;
    private _backgroundImageRev:PIXI.TilingSprite;
    private _bgImageContainer:PIXI.Container;

    private _bgRays:PIXI.Sprite;
    private _respinA:TimelineSprite;
    private _respinB:TimelineSprite;


    private _bonusA:PIXI.Sprite;
    private _bonusB:PIXI.Sprite;
    private _bonusBGloss:TimelineSprite;
    private _bonusC:PIXI.Sprite;
    private _starUpper:TimelineSprite;
    private _starLower:TimelineSprite;

    private static pos = {
        port : {
            respinA : {x : 640, y : 10},
            respinB : {x : 640, y : 130},
            bgRays : {x : 640, y : 500},
            bonusA : {x : 640, y : 660},
            bonusC : {x : 640, y : 710},
            bonusB : {x : 640, y : 710},
            bonusBGloss : {x : 640, y : 710},
            starUpper : {x : 640, y : 590},
            starLower : {x : 640, y : 780},

        },
        land : {
            respinA : {x : 384, y : 260},
            respinB : {x : 384, y : 380},
            bgRays : {x : 384, y : 360},
            bonusA : {x : 1024, y : 260},
            bonusC : {x : 1024, y : 310},
            bonusB : {x : 1024, y : 310},
            bonusBGloss : {x : 1024, y : 310},
            starUpper : {x : 1024, y : 190},
            starLower : {x : 1024, y : 380},
        }
    };
    private _respinAX:number;
    private _respinBX:number;
    private _bonusBY:number;
    private _bonusAX:number;
    private _bonusCX:number;


    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BONUS_GAME_PRE_INTRO.name);
    }

    protected initAnimations():void {
        this._bgImageContainer = new PIXI.Container();
        this._bgImageContainer.alpha = 0;

        this._container = new PIXI.Container();

        this._layer.addChild(this._bgImageContainer);
        this._layer.addChild(this._container);

        this.createStickyGraphics();
        this.createBonusGraphics();
    }

    private createStickyGraphics() {

        // --- main
        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(FruitsGameAssets.BONUS_BG_LANDSCAPE)[0],
            GameConfig.instance.GAME_WIDTH * 0.6,
            GameConfig.instance.GAME_HEIGHT
        );

        this._backgroundImageRev = new PIXI.TilingSprite(
            GameResources.getTextures(FruitsGameAssets.BONUS_BG_LANDSCAPE_REV)[0],
            GameConfig.instance.GAME_WIDTH * 0.4,
            GameConfig.instance.GAME_HEIGHT
        );

        this._bgRays = new PIXI.Sprite(GameResources.getTextures("Bg_Rays")[0]);
        this._bgRays.blendMode = PIXI.BLEND_MODES.ADD;
        this._bgRays.scale.set(2, 1.5);
        this._bgRays.alpha = 1;
        this._bgRays.visible = false;
        this._bgRays.anchor.set(0.5, 0.5);
        this._bgRays.position.set(BigStickySymbolAndBonusView.pos.land.bgRays.x, BigStickySymbolAndBonusView.pos.land.bgRays.y);

        this._respinA = new TimelineSprite(GameResources.getTextures("Respin_A"));
        this._respinA.alpha = 0;
        this._respinA.anchor.set(0.5, 0.5);
        this._respinA.position.set(BigStickySymbolAndBonusView.pos.land.respinA.x, BigStickySymbolAndBonusView.pos.land.respinA.y);

        this._respinB = new TimelineSprite(GameResources.getTextures("Respin_B"));
        this._respinB.alpha = 0;
        this._respinB.anchor.set(0.5, 0.5);
        this._respinB.position.set(BigStickySymbolAndBonusView.pos.land.respinB.x, BigStickySymbolAndBonusView.pos.land.respinB.y);

        this._container.addChild(this._bgRays);
        this._container.addChild(this._respinA);
        this._container.addChild(this._respinB);

    }


    private createBonusGraphics() {

        this._bonusA = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.BONUS_A)[0]);
        this._bonusA.anchor.set(0.5, 0.5);
        this._bonusA.alpha = 0;
        this._bonusA.scale.set(0.5, 0.5);
        this._bonusA.position.set(BigStickySymbolAndBonusView.pos.land.bonusA.x, BigStickySymbolAndBonusView.pos.land.bonusA.y);

        this._bonusB = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.BONUS_B)[0]);
        this._bonusB.anchor.set(0.5, 0.5);
        this._bonusB.alpha = 0;
        this._bonusB.scale.set(0.5, 0.5);
        this._bonusB.position.set(BigStickySymbolAndBonusView.pos.land.bonusB.x, BigStickySymbolAndBonusView.pos.land.bonusB.y);

        this._bonusBGloss = new TimelineSprite(GameResources.getTextures("Bonus_B_Gloss"));
        this._bonusBGloss.anchor.set(0.5, 0.5);
        this._bonusBGloss.scale.set(1, 1);
        this._bonusBGloss.blendMode = PIXI.BLEND_MODES.ADD;
        this._bonusBGloss.hide();
        this._bonusBGloss.position.set(BigStickySymbolAndBonusView.pos.land.bonusBGloss.x, BigStickySymbolAndBonusView.pos.land.bonusBGloss.y);

        this._bonusC = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.BONUS_C)[0]);
        this._bonusC.anchor.set(0.5, 0.5);
        this._bonusC.scale.set(0.5, 0.5);
        this._bonusC.alpha = 0;
        this._bonusC.position.set(BigStickySymbolAndBonusView.pos.land.bonusC.x, BigStickySymbolAndBonusView.pos.land.bonusC.y);

        this._starUpper = new TimelineSprite(GameResources.getTextures("Star_Intro"));
        this._starUpper.anchor.set(0.5, 0.5);
        this._starUpper.scale.set(0.5, 0.5);
        this._starUpper.hide();
        this._starUpper.position.set(BigStickySymbolAndBonusView.pos.land.starUpper.x, BigStickySymbolAndBonusView.pos.land.starUpper.y);

        this._starLower = new TimelineSprite(GameResources.getTextures("Star_Intro"));
        this._starLower.anchor.set(0.5, 0.5);
        this._starLower.scale.set(0.5, 0.5);
        this._starLower.hide();
        this._starLower.position.set(BigStickySymbolAndBonusView.pos.land.starLower.x, BigStickySymbolAndBonusView.pos.land.starLower.y);

        this._container.addChild(this._bonusB);
        this._container.addChild(this._bonusBGloss);
        this._container.addChild(this._starUpper);
        this._container.addChild(this._starLower);
        this._container.addChild(this._bonusA);
        this._container.addChild(this._bonusC);
    }

    protected onResize(resizeData:IResizeData):void {
        this._bgImageContainer.removeChild(this._backgroundImage);
        this._bgImageContainer.removeChild(this._backgroundImageRev);

        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._leftOffset = -this._layer.x / this._layer.scale.x;
        this._topOffset = -this._layer.y / this._layer.scale.y;
        this._screenX = this._screenWidth + this._leftOffset;
        this._screenY = this._screenHeight + this._topOffset;
        this._centerX = this._screenWidth / 2 + this._leftOffset;
        this._centerY = this._screenHeight / 2 + this._topOffset;

        if(this._orientation !== resizeData.orientation) {
            this._orientation = resizeData.orientation;
            this.reposition();
        }

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this.resizeForPortrait();
        } else {
            this.resizeForLandscape();
        }
    }

    private resizeForPortrait():void {
        let spriteTexture = FruitsGameAssets.BONUS_BG_PORTRAIT;
        this._screenHeight *= 1.1;
        let sizeA = Math.round((this._screenY + 2 / 3 * this._topOffset) * .8);
        let sizeB = this._screenHeight - sizeA * .75;

        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(spriteTexture)[0],
            this._screenWidth,
            sizeA
        );

        this._backgroundImageRev = new PIXI.TilingSprite(
            GameResources.getTextures(spriteTexture)[0],
            this._screenWidth,
            sizeB
        );

        this._backgroundImage.anchor.set(0.5, 0);
        this._backgroundImage.position.set(this._centerX, -420);


        this._backgroundImageRev.anchor.set(0.5, 0);
        this._backgroundImageRev.position.set(this._centerX, sizeA - 420);

        this._bgImageContainer.addChild(this._backgroundImage);
        this._bgImageContainer.addChild(this._backgroundImageRev);

        // ----

        this._bgRays.rotation = 90 * PIXI.DEG_TO_RAD;
        this._bgRays.scale.set(1.5, 2);

    }

    private resizeForLandscape():void {
        let spriteTexture = FruitsGameAssets.BONUS_BG_LANDSCAPE;
        let spriteTextureRev = FruitsGameAssets.BONUS_BG_LANDSCAPE_REV;

        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(spriteTexture)[0],
            this._screenWidth * .6,
            this._screenHeight
        );

        this._backgroundImageRev = new PIXI.TilingSprite(
            GameResources.getTextures(spriteTextureRev)[0],
            this._screenWidth * .4,
            this._screenHeight
        );

        this._backgroundImage.tileScale.y = this._screenHeight / 720;
        this._backgroundImage.anchor.set(0, 0.5);
        this._backgroundImage.position.set(this._leftOffset, this._centerY);

        this._backgroundImageRev.tileScale.y = this._screenHeight / 720;
        this._backgroundImageRev.anchor.set(0, 0.5);
        this._backgroundImageRev.position.set((this._screenX + this._leftOffset * 2 / 3) * 0.6, this._centerY);
        this._bgImageContainer.addChild(this._backgroundImage);
        this._bgImageContainer.addChild(this._backgroundImageRev);

        // ----

        this._bgRays.rotation = 0;
        this._bgRays.scale.set(2, 1.5);
    }

    private reposition():void {

        if(this._orientation === Orientation.PORTRAIT) {
            this._bgRays.position.set(BigStickySymbolAndBonusView.pos.port.bgRays.x, BigStickySymbolAndBonusView.pos.port.bgRays.y);
            this._respinA.position.set(BigStickySymbolAndBonusView.pos.port.respinA.x, BigStickySymbolAndBonusView.pos.port.respinA.y);
            this._respinB.position.set(BigStickySymbolAndBonusView.pos.port.respinB.x, BigStickySymbolAndBonusView.pos.port.respinB.y);
            this._bonusA.position.set(BigStickySymbolAndBonusView.pos.port.bonusA.x, BigStickySymbolAndBonusView.pos.port.bonusA.y);
            this._bonusB.position.set(BigStickySymbolAndBonusView.pos.port.bonusB.x, BigStickySymbolAndBonusView.pos.port.bonusB.y);
            this._bonusBGloss.position.set(BigStickySymbolAndBonusView.pos.port.bonusBGloss.x, BigStickySymbolAndBonusView.pos.port.bonusBGloss.y);
            this._bonusC.position.set(BigStickySymbolAndBonusView.pos.port.bonusC.x, BigStickySymbolAndBonusView.pos.port.bonusC.y);
            this._starUpper.position.set(BigStickySymbolAndBonusView.pos.port.starUpper.x, BigStickySymbolAndBonusView.pos.port.starUpper.y);
            this._starLower.position.set(BigStickySymbolAndBonusView.pos.port.starLower.x, BigStickySymbolAndBonusView.pos.port.starLower.y);

            this._respinAX = BigStickySymbolAndBonusView.pos.port.respinA.x;
            this._respinBX = BigStickySymbolAndBonusView.pos.port.respinB.x;
            this._bonusBY = BigStickySymbolAndBonusView.pos.port.bonusB.y;
            this._bonusAX = BigStickySymbolAndBonusView.pos.port.bonusA.x;
            this._bonusCX = BigStickySymbolAndBonusView.pos.port.bonusC.x;
        } else {
            this._bgRays.position.set(BigStickySymbolAndBonusView.pos.land.bgRays.x, BigStickySymbolAndBonusView.pos.land.bgRays.y);
            this._respinA.position.set(BigStickySymbolAndBonusView.pos.land.respinA.x, BigStickySymbolAndBonusView.pos.land.respinA.y);
            this._respinB.position.set(BigStickySymbolAndBonusView.pos.land.respinB.x, BigStickySymbolAndBonusView.pos.land.respinB.y);
            this._bonusA.position.set(BigStickySymbolAndBonusView.pos.land.bonusA.x, BigStickySymbolAndBonusView.pos.land.bonusA.y);
            this._bonusB.position.set(BigStickySymbolAndBonusView.pos.land.bonusB.x, BigStickySymbolAndBonusView.pos.land.bonusB.y);
            this._bonusBGloss.position.set(BigStickySymbolAndBonusView.pos.land.bonusBGloss.x, BigStickySymbolAndBonusView.pos.land.bonusBGloss.y);
            this._bonusC.position.set(BigStickySymbolAndBonusView.pos.land.bonusC.x, BigStickySymbolAndBonusView.pos.land.bonusC.y);
            this._starUpper.position.set(BigStickySymbolAndBonusView.pos.land.starUpper.x, BigStickySymbolAndBonusView.pos.land.starUpper.y);
            this._starLower.position.set(BigStickySymbolAndBonusView.pos.land.starLower.x, BigStickySymbolAndBonusView.pos.land.starLower.y);

            this._respinAX = BigStickySymbolAndBonusView.pos.land.respinA.x;
            this._respinBX = BigStickySymbolAndBonusView.pos.land.respinB.x;
            this._bonusBY = BigStickySymbolAndBonusView.pos.land.bonusB.y;
            this._bonusAX = BigStickySymbolAndBonusView.pos.land.bonusA.x;
            this._bonusCX = BigStickySymbolAndBonusView.pos.land.bonusC.x;
        }

    }


    public getAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const bgRayTL:TimelineLite = new TimelineLite();
        bgRayTL.add([
            () => this._bgRays.visible = true,
            TweenLite.to(this._bgRays, 1, {alpha : 0}),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_SPLASH_SCREEN)
        ]);
        tl.add(TweenLite.to(this._bgImageContainer, 0.25, {alpha : 0.7}));
        tl.add([

            TweenLite.fromTo(this._respinA.position, 0.25, {x : this._respinAX - 150}, {
                x : this._respinAX + 10,
                ease : Back.easeOut.config(1.5)
            }),
            TweenLite.fromTo(this._respinB.position, 0.25, {x : this._respinBX + 150}, {
                x : this._respinBX - 10,
                ease : Back.easeOut.config(1.5)
            }),
            TweenLite.to(this._respinA, 0.15, {alpha : 1}),
            TweenLite.to(this._respinB, 0.15, {alpha : 1})
        ]);

        tl.add([
            TweenLite.to(this._respinA.position, 0.4, {x : this._respinAX}),
            TweenLite.to(this._respinB.position, 0.4, {x : this._respinBX})
        ]);

        tl.add(bgRayTL, "-= 0.85");
        tl.add(() => FruitsGameModuleConfig.logoAnimationBit.changeLogo(FruitsGameMode.STICKY_RESPIN), "-= 0.85");

        tl.add(this.bonusAnimation());
        tl.add([
            TweenLite.to(this._container, 0.4, {alpha : 0}),
        ], "+=0.5");

        tl.add(() => this.resetView());
        tl.add(() => EventHandler.dispatchEvent(new GameEvent(BigStickySymbolController.STICK_SYMBOLS)));

        return tl;
    }

    private bonusAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            TweenLite.fromTo(this._bonusB.position, 0.25, {y : this._bonusBY - 240}, {
                y : this._bonusBY,
                ease : Back.easeOut.config(1.5)
            }),
            TweenLite.to(this._bonusB, 0.15, {alpha : 1}),
            TweenLite.to(this._bonusA, 0.15, {alpha : 1}),
            TweenLite.to(this._bonusC, 0.15, {alpha : 1}),
            TweenLite.fromTo(this._bonusA.position, 0.25, {x : this._bonusAX - 150}, {
                x : this._bonusAX + 10,
                ease : Back.easeOut.config(1.5)
            }),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INTRO_SPLASH),
            TweenLite.fromTo(this._bonusC.position, 0.25, {x : this._bonusCX + 150}, {
                x : this._bonusCX - 10,
                ease : Back.easeOut.config(1.5)
            }),

        ]);
        tl.add([
            () => {
                this._starUpper.show();
                this._starLower.show();
                this._starUpper.playLoop();
                this._starLower.playLoop();
            },
            TweenLite.to(this._bonusA.position, 0.4, {x : this._bonusAX}),
            TweenLite.to(this._bonusC.position, 0.4, {x : this._bonusCX})
        ]);

        return tl;
    }


    private resetView() {

        this._respinA.alpha = 0;
        this._respinB.alpha = 0;
        this._bgRays.visible = false;
        this._bgRays.alpha = 1;

        this._bonusB.alpha = 0;

        this._bonusBGloss.hide();
        this._bonusA.alpha = 0;

        this._bonusC.alpha = 0;

        this._starUpper.hide();
        this._starLower.hide();

        this.reposition();


        this._bgImageContainer.alpha = 0;
        this._container.alpha = 1;

    }
}

















